module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Battery-empty-c569a748da1466493e4012c1901ab8c2.svg";